// src/utils/push.js
// Asks permission, subscribes the browser to push, saves it to your backend.
import API from "./api";

// Your VAPID PUBLIC key (matches VAPID_PUBLIC_KEY in Render)
const VAPID_PUBLIC_KEY =
  "BNqg_GaLSYCmk9P2niZ2dF_v25sjsTfFR8RBQgl6BLJ3qcYVpYAq0TCw_Nt7BaQoHdF00wkWlxsN_r1L_C-6V3w";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeToPush(userId) {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.warn("Push not supported on this browser.");
      return { ok: false, reason: "unsupported" };
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted:", permission);
      return { ok: false, reason: "denied" };
    }

    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }

    await API.post("/push/subscribe", { userId, subscription });

    console.log("✅ Push subscription saved");
    return { ok: true, subscription };
  } catch (err) {
    console.error("❌ Push subscription failed:", err);
    return { ok: false, reason: err.message };
  }
}

export async function unsubscribeFromPush(userId) {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
      await API.post("/push/unsubscribe", { userId });
    }
    return { ok: true };
  } catch (err) {
    console.error("Unsubscribe failed:", err);
    return { ok: false };
  }
}
